var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 18,
    viewBox: "0 0 154 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68013 0.30237C16.9475 -0.0801397 19.2426 6.42237 19.2426 6.42237L16.1826 6.42237C16.1826 6.42237 14.0941 2.59737 9.68013 2.59737C6.19293 2.59737 3.07959 5.23154 3.17764 8.71736C3.27604 12.216 6.56599 14.6075 10.0626 14.4549C13.7674 14.2931 16.1826 11.0124 16.1826 11.0124H10.4451V9.09986H19.2426V16.3674L17.33 16.3674V14.4549V14.4386C17.33 14.4386 14.2067 17.0876 10.0626 17.0788C4.97509 17.0681 0.470974 13.8048 0.500141 8.71736C0.528022 3.85413 4.32501 0.584232 9.68013 0.30237Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8251 16.3674V1.06737H83.885V6.80487H94.9775V1.06737H98.0375V16.3674H94.9775V9.09986H83.5025V16.3674H80.8251Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.693 16.3674V1.06737H133.992V3.36237H121.37V7.18737L132.08 6.80487V9.48236H121.37V14.0724H133.992V16.3674H118.693Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.025 8.71736L135.905 1.06737H139.348L144.702 7.18737L149.675 1.06737H153.5L146.997 8.71736L153.5 16.3674H149.675L144.702 10.2474L139.348 16.3674H135.523L142.025 8.71736Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5376 1.06737V16.3674H24.2151V11.3949H31.1001L35.3076 16.3674H38.7501L34.5426 11.3949C34.5426 11.3949 38.9416 10.2474 38.7501 6.03987C38.5412 1.44987 33.7776 1.06737 33.7776 1.06737H21.5376ZM24.2151 9.09986V3.36237H33.0125C33.0125 3.36237 35.69 3.36238 35.69 6.42237C35.69 9.09987 33.0125 9.09986 33.0125 9.09986H24.2151Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3176 1.44987V16.3674H63.9951V11.3949H74.3226C74.3226 11.3949 78.9126 11.3949 78.9126 6.42237C78.9126 1.44661 73.1751 1.06737 73.1751 1.06737H61.3176V1.44987ZM63.9951 9.09986V2.97987H73.1751C73.1751 2.97987 76.2351 2.95867 76.2351 6.42237C76.2351 9.09986 73.9401 9.09986 73.9401 9.09986H63.9951Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8976 16.3674L48.3126 1.06737H51.7551L59.7876 16.3674H57.1101L54.8151 12.5424H44.8701L42.5751 16.3674H39.8976ZM49.8426 3.36237L46.4001 10.2474H53.6676L49.8426 3.36237Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.95 16.3674V1.06737H110.278C110.278 1.06737 116.398 1.06737 116.398 9.09986C116.398 16.3674 110.278 16.3674 110.278 16.3674H99.95ZM103.01 13.6899V3.74488H110.278C110.278 3.74488 113.72 3.74488 113.72 9.09986C113.72 13.6899 110.278 13.6899 110.278 13.6899H103.01Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/_logo-text.71f75333995420aa0fc9989d76679504.svg";
export { ForwardRef as ReactComponent };